<template>
  <div class="container">
    <div v-if="!changePassword">
      <mad-form @submit.prevent="submit">
        <mad-form-item label="Email">
          <mad-input v-model="form.email" />
        </mad-form-item>
        <mad-form-item label="First name">
          <mad-input v-model="form.first_name" />
        </mad-form-item>
        <mad-form-item label="Last name">
          <mad-input v-model="form.last_name" />
        </mad-form-item>
        <mad-form-item label="User image">
          <image-input v-model="form.user_image" />
        </mad-form-item>

        <mad-button @click="toggle">Change password</mad-button>

        <br>
        <br>

        <div class="spaced-row">
          <mad-button @click="clickCancel">
            <mad-icon mdi="arrow-left" />
          </mad-button>
          <div class="grow"></div>

          <mad-button color="brown" type="submit">
            <mad-icon mdi="check" />
            Save
          </mad-button>
        </div>
      </mad-form>
    </div>
    <div v-else>
      <mad-form @submit.prevent="submit">
        <div v-if="error" class="alert alert-danger" role="alert">
          {{ error }}
        </div>
        <mad-form-item label="Current password">
          <mad-input v-model="form.old_password" type="password" />
        </mad-form-item>
        <mad-form-item label="New password">
          <mad-input v-model="form.new_password" type="password" />
        </mad-form-item>
        <mad-form-item label="Confirm password">
          <mad-input v-model="form.confirmed_password" type="password" />
        </mad-form-item>
        <div class="spaced-row">
          <mad-button @click="toggle">
            <mad-icon mdi="arrow-left" />
          </mad-button>
          <div class="grow"></div>
          <div>
            <mad-button color="brown" @click="change(form.old_password, form.new_password)">
              <mad-icon mdi="check" />
              Save
            </mad-button>
          </div>
        </div>

        <mad-datatable :rows="rows" :columns="columns" :per-page="10">
          <template slot="locations" slot-scope="{row}">
            {{ row.locations }}
          </template>
          <template slot="client vouchers" slot-scope="{row}">
            {{ row.vouchers }}
          </template>
        </mad-datatable>
      </mad-form>
    </div>
  </div>
</template>

<script>
import ImageInput from './inputs/ImageInput'

export default {
  components: {
    ImageInput,
  },

  data: () => ({
    form: {
      email: '',
      old_password: '',
      new_password: '',
      confirmed_password: '',
      first_name: '',
      last_name: '',
      user_image: '',
    },
    changePassword: false,
    error: null,
  }),

  created() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      this.form = this.$store.state.user
    },

    async submit() {
      await this.$store.dispatch('updateUser', this.form)
      this.$mad.message.success('User updated succesfully')
      this.$router.push('/locations')
    },

    async change(oldPassword, newPassword) {
      if (newPassword !== this.confirmed_password) {
        this.error = 'Confirmed password must be identical to your new password'
      } else {
        await this.$store.dispatch('changePassword', { oldPassword, newPassword })
        this.changePassword = false
      }
    },

    clickCancel() {
      this.$router.push(`/locations`)
    },

    toggle() {
      this.changePassword = !this.changePassword
    },
  },
}
</script>

<style>
</style>
